import { useState } from 'react';
import EventMainTab from './forms/EventMainTab';
import DocumentTab from '@pages/DataBase/Documents/DocumentTab';
import { IForm } from '@ts/ui-models';
import { Tabs } from '@ts/storybook';
import Notifications from '../Configuration/Notifications/Notifications';

interface IEventFormProps extends IForm {}

const EventForm = (props: IEventFormProps) => {
  const [state, setState] = useState({ activeTab: 'main' });

  const { mode } = props;
  const tabs = [
    { label: 'Main', value: 'main' },
    { label: 'Documents', value: 'images' },
    {
      label: 'Notifications',
      value: 'notifications',
      disabled: mode === 'new',
    },
  ];

  const _handleTabChange = (event, tab) => {
    setState({ activeTab: tab });
  };

  const _renderContents = () => {
    const { mode, values, onChange } = props;
    const { activeTab } = state;
    const contents = () => {
      switch (activeTab) {
        case 'main':
          return <EventMainTab {...props} />;
        case 'notifications':
          return <Notifications />;
        case 'images':
          return <DocumentTab {...props} entityTypeId="taEvent" />;
        default:
          return <EventMainTab {...props} />;
      }
    };

    return contents();
  };

  return (
    <Tabs id={'event-page'} sticky tabs={tabs} value={state.activeTab} onChange={_handleTabChange}>
      {_renderContents()}
    </Tabs>
  );
};

export default EventForm;
